import type { TRuleWithTheme } from 'styles/theme';

export const cell: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.foregroundsPrimary80,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});
